import React from "react";
import { Container } from "react-bootstrap";
import { Navigation } from "./Navigation";

export const Layout = (props:any) => {
    return (
        <div>
            <Navigation {...props}/>
            <Container fluid>
                {props.children}
            </Container>
        </div>
    );
}